var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('label',_vm._b({staticClass:"h2"},'label',_vm.$attrs,false),[_vm._t("default")],2),_vm._t("subText")],2)}
var staticRenderFns = []

export { render, staticRenderFns }